import PropTypes from 'prop-types';

export default {
  selectedBundleWithExtras: PropTypes.object,
};
